module.exports = __webpack_public_path__ + "img/DJI_0033-2_Schiff_Signaletik.6a757c92.jpg";